module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/reddit_big-e1a54cea30ad52bb554f51cddaea0058.svg";